import permissionsRegistry from "../data/permissions.json" with { type: "json" };
export const permissions = permissionsRegistry;
function permissionCodeToScreamingSnakeKey(permissionCode) {
    return permissionCode.replace(/\./g, "_").toUpperCase();
}
export const Permission = Object.keys(permissionsRegistry).reduce((accumulator, permissionCode) => {
    const key = permissionCodeToScreamingSnakeKey(permissionCode);
    accumulator[key] = permissionCode;
    return accumulator;
}, {});
//# sourceMappingURL=permissions.js.map